module.exports = __webpack_public_path__ + "static/media/3.2_preview.072ca031.png";